import { FC } from 'react';
import { IPageStatus } from '../../../type';
import styled from './index.module.scss';
import GiftIcon from './GiftIcon';
import DiscountIcon from './DiscountIcon';
import CouponIcon from './CouponIcon';
import JPTimeLine from './JPTimeLine';
import { useLang } from '@/i18n';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    type?: string;
}

const MembersTimeLine: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.memberstimeline');
    const { t: _t } = useLang('membersday.activity.memberstimeline');
    const { locale } = getLocal();
    const { pageStatus } = useMembersStore();

    // const list =
    const lang_t = locale === 'kr' && (pageStatus === IPageStatus.ACTIVITY || pageStatus === IPageStatus.RETURN) ? _t : t;

    return (
        <div className={`${styled.MembersTimeLine}`}>
            <h3 className="timeline_title">{lang_t('title')}</h3>
            {locale !== 'jp' ? (
                <ul className="timeline_list">
                    <li className={`timeline_item ${pageStatus === IPageStatus.TEASER && 'active'}`}>
                        <GiftIcon />
                        <h6 className="timeline_item_title">{lang_t('list1_name')}</h6>
                        <p className="timeline_item_desc">
                            {lang_t.rich('list1_desc', {
                                line: (text: string) => <span>{text}</span>,
                            })}
                        </p>
                    </li>
                    <li className={`timeline_item ${pageStatus === IPageStatus.ACTIVITY && 'active'}`}>
                        <DiscountIcon statu={pageStatus === IPageStatus.ACTIVITY ? 'activity' : 'default'} />
                        <h6 className="timeline_item_title">{lang_t('list2_name')}</h6>
                        <p className="timeline_item_desc">
                            {lang_t.rich('list2_desc', {
                                line: (text: string) => <span>{text}</span>,
                            })}
                        </p>
                    </li>
                    {locale !== 'au' && (
                        <li className={`timeline_item ${pageStatus === IPageStatus.RETURN && 'active'}`}>
                            <CouponIcon />
                            <h6 className="timeline_item_title">{lang_t('list3_name')}</h6>
                            <p className="timeline_item_desc">
                                {lang_t.rich('list3_desc', {
                                    line: (text: string) => <span>{text}</span>,
                                })}
                            </p>
                        </li>
                    )}
                </ul>
            ) : (
                <JPTimeLine />
            )}
        </div>
    );
};

export default MembersTimeLine;
